import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timeline" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px border-primary" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light-primary border border-primary" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_6 = { class: "timeline-content mb-10 mt-n1 bg-secondary px-4 py-2 border border-secondary rounded" }
const _hoisted_7 = { class: "mb-5 pe-3" }
const _hoisted_8 = {
  href: "#",
  class: "fs-5 fw-bold text-gray-800 text-hover-primary mb-2"
}
const _hoisted_9 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_10 = { class: "text-gray-800 me-2 fs-7" }
const _hoisted_11 = {
  class: /*#__PURE__*/_normalizeClass('badge badge-light')
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "symbol symbol-circle symbol-25px d-none",
  "data-bs-toggle": "tooltip",
  "data-bs-boundary": "window",
  "data-bs-placement": "top",
  title: "Jan Hummer"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/avatars/300-23.jpg",
    alt: "img"
  })
], -1)
const _hoisted_13 = {
  key: 0,
  class: "overflow-auto pb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_itemFile = _resolveComponent("itemFile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listHistory, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "timeline-item",
        key: 'lst-h-' + index
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(item.message), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.created_at), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.mstatus), 1),
              _hoisted_12
            ])
          ]),
          (item.files.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_itemFile, {
                  view: 'rectangle',
                  files: item.files
                }, null, 8, ["files"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}